import Lottie from 'lottie-react'
import Loading from '@/assets/lottie/loading.json'

const LoadingScreen = () => {
    return (
        <div className="flex items-center justify-center w-screen h-container-header">
            <Lottie animationData={Loading} className="md:w-1/6" />
        </div>
    )
}

export default LoadingScreen
